var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDragGrip = function SvgDragGrip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.75,
    cy: 2.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.25,
    cy: 2.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.75,
    cy: 7,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.25,
    cy: 7,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.75,
    cy: 11.5,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.25,
    cy: 11.5,
    r: 1.25
  }))));
};
export default SvgDragGrip;